import React, { useEffect, useState } from "react";
import { Box, Divider } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import axios from "axios";
import { loadAction, loadAlert } from "redux/reducers/top";
import { loadEventAction, resetEvent } from "redux/reducers/event/index";
import { rem, evtDateFormat, renderNoti } from "assets/js/common";
import InnerHTML from "dangerously-set-html-content";
import Comment from "components/event/comment";
import { useParams, useHistory } from "react-router-dom";
import Share from "components/ui/share";
import LazyCDNImage from "components/utils/lazy-cdn-image";
import FavoriteItem from "components/event/detail/favorite";
import StampWrap from "components/stamp/stamp-wrap";
import Loading from "components/ui/loading";
import PullToRefresh from "react-simple-pull-to-refresh";
import Spinner from "components/ui/spinner";
import { Cookies } from "react-cookie";
import { setAppData } from "assets/js/apphandle";

const useStyles = makeStyles((theme) => ({
  detail: {
    "& .tit": {
      fontSize: rem(18),
      fontWeight: 800,
    },
    "& .sub-tit": {
      paddingTop: rem(6),
      fontSize: rem(14),
      lineHeignt: rem(22),
      color: theme.palette.info.main,
    },
    "& .board-info": {
      marginTop: rem(7),
      "& .date": {
        display: "inline-block",
        fontSize: rem(12),
        color: theme.palette.info.main,
        "& + span": {
          paddingLeft: rem(8),
          marginLeft: rem(8),
          "&::before": {
            content: "''",
            position: "absolute",
            top: "50%",
            left: 0,
            transform: "translateY(-50%)",
            height: "50%",
            width: "1px",
            backgroundColor: theme.palette.info.light,
          },
        },
      },
    },
    "& .eventImg": {
      "& img": {
        width: "100%",
      },
    },
    "& .info": {
      padding: "40px 30px",
      borderBottom: "1px solid #eee",
      "& table": {
        fontSize: rem(14),
        borderCollapse: "0",
        borderSpacing: "0",
        "& tr": {
          "& th": {
            display: "flex",
            width: rem(80),
            textAlign: "left",
            fontWeight: 800,
          },
          "& td": {
            wordBreak: "keep-all",
            lineHeight: rem(22),
          },
          "& + tr th, & + tr td": {
            paddingTop: rem(20),
          },
        },
      },
    },
    "& .bottom-wrap": {
      display: "flex",
      flexDirection: "column",
      marginTop: rem(15),
      "& button": {
        marginTop: `${rem(40)}`,
        "&.btnYellow": {
          backgroundColor: "#FFBB53",
        },
      },
    },

    "& .fav-box": {
      padding: `${rem(30)} ${rem(30)} ${rem(60)}`,
      "& + .fav-comment": {
        marginTop: rem(-20),
      },
    },
    "& .cont": {
      width: "100%",
      wordBreak: "break-all",
    },
  },
}));

export default function EventDetail() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { alertOpen, appCardOpen, favAlertOpen } = useSelector(
    (state) => state.top
  );

  let cookies = new Cookies();

  let favInfo = cookies.get("favInfo");

  const storeCode = favInfo
    ? favInfo.visibleTp === "1"
      ? favInfo.favMt
      : favInfo.favMk
    : "";

  const { seq } = useParams();
  const { schForm, event, loading } = useSelector((state) => state.event);

  const history = useHistory();

  const displayStamp = () => {
    // 이벤트유형(1: 기본형, 2: 댓글형, 3: 출석체크형, 4: 출석체크+댓글형, 5: 정보제출형, 6: 스탬프형, 7: 스탬프+댓글형)
    return (
      event.evtTp == "3" ||
      event.evtTp == "4" ||
      event.evtTp == "6" ||
      event.evtTp == "7"
    );
  };

  const displayComment = () => {
    // 이벤트유형(1: 기본형, 2: 댓글형, 3: 출석체크형, 4: 출석체크+댓글형, 5: 정보제출형, 6: 스탬프형, 7: 스탬프+댓글형)
    return (event.evtTp == "2" || event.evtTp == "4" || event.evtTp == "7");
  };

  window.appBackKeyHandle = () => {
    let loginModalEl = document.getElementById("loginModal");
    let alertModalEl = document.getElementById("alertModal");

    if (loginModalEl && loginModalEl.style.display == "block") {
      loginModalEl.style.display = "none";
    } else if (alertModalEl && alertModalEl.style.display == "block") {
      alertModalEl.style.display = "none";
    } else if (alertOpen) {
      dispatch(loadAlert(false));
    } else {
      history.goBack();
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(
      loadEventAction({
        seq: seq,
        storeCode: storeCode || "ALL",
        schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
      })
    );
    cookies.remove("referrer", { path: "/" });
    setAppData();
    return () => {
      dispatch(resetEvent());
    };
  }, []);

  useEffect(() => {
    if (event.expsYn == "N") {
      history.replace("/notFound");
    } else if (event.expsEndYmd && event.expsStrtYmd) {
      let today = moment(moment().format("YYYYMMDD"));
      if (
        moment(event.expsEndYmd) < today ||
        today < moment(event.expsStrtYmd)
      ) {
        //history.replace("/notFound");
      }
    }
  }, [event]);

  const { init } = useSelector((state) => state.top);
  useEffect(() => {
    if (init)
      dispatch(loadAction({ back: true, title: "이벤트", menu: false }));

    return () => {
      setAppData();
    };
  }, [init]);

  const handleRefresh = () => {
    return new Promise((resolve) => {
      dispatch(
        loadEventAction({
          seq: seq,
          storeCode: storeCode || "ALL",
          schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
        })
      );
      resolve(event);
    });
  };

  const goLogin = () => {
    var cookieExpires = new Date();
    cookieExpires.setDate(cookieExpires.getDate() + 180);
    setCookie("referrer", window.location.pathname, cookieExpires, "/");
    // window.location.href = "/login?edit=Y";
    history.push({
      pathname: "/login",
      state: {
        from: {
          pathname: location.pathname,
        },
      },
    });
    document.getElementsByTagName("body")[0].style.overflow = "visible";
  };

  const onConfirm = () => {
    var layerModal = document.getElementById("alertModal");
    var layerBody = document.getElementsByTagName("body")[0];
    layerModal.style.opacity = 0;
    layerModal.style.zIndex = "-1";
    layerBody.style.overflow = "visible";

    dispatch(
      loadEventAction({
        seq: seq,
        storeCode: storeCode || "ALL",
        schTp: favInfo && favInfo.visibleTp ? favInfo.visibleTp : 1,
      })
    );
  };

  return (
    <>
      <Loading open={loading ? true : false} />
      <PullToRefresh
        onRefresh={handleRefresh}
        pullingContent={false}
        refreshingContent={<Spinner />}
      >
        <div className={"container " + classes.detail}>
          {/* {loading ? (
        <>
          <Box className="box-type-4">
            <Skeleton height={40} />
            <Skeleton height={30} />
            <Skeleton height={30} width={200} />
          </Box>
          <Box>
            <Skeleton width={"100%"} variant="rectangular" height={500} />
          </Box>
          <Box className="box-type-4">
            <Skeleton height={30} width={100} />
            <Skeleton height={30} />
            <Skeleton height={30} width={200} />
            <Skeleton height={30} />
            <Skeleton height={30} width={200} />
          </Box>
        </>
      ) :  */}

          <>
            <Box className="box-type-4">
              <div className="tit">{event.ttl}</div>
              <div className="sub-tit">{event.desc}</div>
              <div className="board-info">
                <div className="date">
                  {evtDateFormat(event.evtStrtYmd, event.evtEndYmd)}
                </div>
                <span>이벤트</span>
              </div>
            </Box>
            <div style={{ padding: "30px" }}>
              <InnerHTML className="cont" html={event.topCont} />
            </div>


            {/* stamp */}
            {displayStamp() && (
              <div
                style={{
                  backgroundImage: `${"url(" + event.bgImgUrl + ")"}`,
                  backgroundSize: "100% auto",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <StampWrap
                  event={event}
                  bgYn="Y"
                  fetchData={() => {
                    dispatch(
                      loadEventAction({
                        seq: event.seq,
                        storeCode: storeCode || "ALL",
                      })
                    );
                  }}
                />
              </div>
            )}

            <InnerHTML html={event.botCont} />

            <form
              name="quizForm"
              id="quizForm"
              method="GET"
              acceptCharset="EUC-KR"
            >
              <input type="hidden" id="P_FLAG" name="P_FLAG" value="T" />
              <input type="hidden" id="EVENT_NAME" name="EVENT_NAME" value="" />
              <input
                type="hidden"
                id="CUSTOMER_CODE"
                name="CUSTOMER_CODE"
                value=""
              />
              <input
                type="hidden"
                id="EVENT_ANSWER"
                name="EVENT_ANSWER"
                value=""
              />
            </form>
            {event.noti && (
              <Box className="box-type-1">
                <Box className="notice">
                  <p className="title">
                    <i className="ico-noti" />
                    유의사항
                  </p>
                  <ul className="list list-dot color-info font-14">
                    {renderNoti(event.noti).map((item, i) => (
                      <li key={i}>{item}</li>
                    ))}
                  </ul>
                </Box>
              </Box>
            )}

            <Divider />
            {moment(event.evtStrtYmd) <= moment(moment().format("YYYYMMDD")) && moment(event.evtEndYmd) >= moment(moment().format("YYYYMMDD")) && (
              <Box className="box-type-1 fav-box">
                <FavoriteItem mode={"event"} item={event} />
              </Box>
            )}

            {displayComment() && <Comment item={event} />}
          </>
        </div>
      </PullToRefresh>
      {moment(event.evtStrtYmd) <= moment(moment().format("YYYYMMDD")) && moment(event.evtEndYmd) >= moment(moment().format("YYYYMMDD")) && (
        <Share />
      )}


      {/* 에디터 알림 팝업 */}
      <div id="loginModal" className="layerPop">
        <div className="dialog">
          <h2>알림</h2>
          <div className="dialog-content">
            로그인이 필요한 서비스입니다.
            <br />
            로그인 하시겠습니까?
          </div>
          <div className="dialog-btn">
            <button className="btn-cancel">취소</button>
            <button className="btn-confirm" onClick={goLogin}>
              확인
            </button>
          </div>
        </div>
      </div>

      <div id="alertModal" className="layerPop">
        <div className="dialog">
          <h2>알림</h2>
          <div id="alertCont" className="dialog-content" />
          <div className="dialog-btn">
            <button className="btn-confirm" onClick={onConfirm}>
              확인
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
